var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"marker",attrs:{"width":"25","height":"44","src":"https://api.longdo.com/map/images/pin.png"}})}
var staticRenderFns = []

export { render, staticRenderFns }